export default "__VITE_ASSET__CaK0USr0__"